import { Model } from 'pinia-orm';
import Company from './Company';
import CompanyUser from './CompanyUser';
import User from './User';

export default class EmailSignature extends Model {

    static get entity() {
        return 'email_signatures';
    }

    static fields () {
        return {
            id: this.uid(),
            name: this.string(''),
            content: this.string(''),
            user_id: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            // relations
            user: this.belongsTo(User, 'user_id'),
            companyUsers: this.hasMany(CompanyUser, 'default_email_signature_id'),
            associatedCompanies: this.belongsToMany(Company, CompanyUser, 'default_email_signature_id', 'company_id'),
        }
    }
}
